





















































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwApp } from '@libs-uuif/shared/sw-app';
import { MswAppHeader } from '../msw-app-header';
import { MswAppNav } from '../msw-app-nav';
import { Getter, State, Mutation } from 'vuex-class';
import { MswPageTheme } from '@/shared/msw-types';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import HelpContainerSlide from './components/help-container-slide.vue';
import AlertSlider from '../../modules/msw-alert-slider/components/alert-slider.vue';
import SupportCaseSlider from './../../modules/msw-support-cases/components/support-case-slider.vue';
import { CoreStoreState, SetHelpContainerSlideVisiblePayload, SetHelpContentIdPayload, StorePageViewWidthPayload, SetAlertSliderVisiblePayload, SetSupportCasesSliderVisiblePayload } from '../core.store';
import { RootStoreState } from '@/store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import MswStatusInfo from './components/status-info.vue';
import UUIFComponents from '@/shared/uuifComponent';
import MswAppFooter from '../msw-app-footer/msw-app-footer.vue';
import { envCongif } from '@/shared/env.config';
import idb from '@/services/indexedDb.service';
import StarRatingComponent from '@/shared/star-rating-component/star-rating-component.vue';
import { currentUserKey } from '@/shared/msw-constants';
import { i18nService } from '@sonicwall/unified-ui-framework/src/shared/i18n-service';

// tslint:disable-next-line:no-unused
declare var feedbackWorkspace: Function;

@Component({
  components: {
    ...UUIFComponents,
    HelpContainerSlide,
    AlertSlider,
    SupportCaseSlider,
    MswAppHeader,
    MswAppNav,
    MswAppFooter,
    SwApp,
    SwBlockingProgress,
    MswStatusInfo,
    StarRatingComponent,
    // SwScrollView,
  },
})
export default class MswAppContent extends Vue {
  defconDialogSrc : string = '';
  showSpogCurtain : boolean = false;
  isShow:boolean = false;
  addClass: boolean = false;
  isSpoginUrl: boolean = false;
  hideHeaderInSpog : boolean = true;
  removeMinCriteria : boolean = false;
  @Getter
  effectivePageTheme: MswPageTheme;
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;

  @State((state: RootStoreState) => state.CoreStoreModule.hideNavToggle)
  hideNavToggle: CoreStoreState['hideNavToggle'];

  @Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @Mutation
  readonly setSupportCaseSliderVisible: VuexMappedMutation<SetSupportCasesSliderVisiblePayload>;

  @Mutation
  readonly setAlertSliderVisible: VuexMappedMutation<SetAlertSliderVisiblePayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.helpContainerSlideVisible)
  helpContainerSlideVisible: CoreStoreState['helpContainerSlideVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.supportCaseSliderVisible)
  supportCaseSliderVisible: CoreStoreState['supportCaseSliderVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.alertSliderVisible)
  alertSliderVisible: CoreStoreState['alertSliderVisible'];

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Mutation
  storePageViewWidth: VuexMappedMutation<StorePageViewWidthPayload>;

  @State((state:RootStoreState) => state.CoreStoreModule.selectedHelpId)
  selectedHelpId: CoreStoreState['selectedHelpId'];
  showFeedBackDialog: boolean = false;

  @Watch('selectedHelpId')
  private navDataUpdated() {
    if (this.$router.currentRoute.path.indexOf('dashboard') > -1
      || this.$router.currentRoute.path.indexOf('register-products') > -1
      || this.$router.currentRoute.path.indexOf('products') > -1
      || this.$router.currentRoute.path.indexOf('activitylogs') > -1
      || this.$router.currentRoute.path.indexOf('download-center') > -1
      || this.$router.currentRoute.path.indexOf('usage-report') > -1
      || this.$router.currentRoute.path.indexOf('claimsreport') > -1
      || this.$router.currentRoute.path.indexOf('mssp-tenant-mgmt') > -1
      || this.$router.currentRoute.path.indexOf('psa-integration') > -1
      || this.$router.currentRoute.path.indexOf('mssp-access-management') > -1
      || this.$router.currentRoute.path.indexOf('catalog') > -1) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  private onRequestCloseSlide() {
    this.setHelpContainerSlideVisible({ visible: false });
  }

  private closeAlertSlider() {
    this.setAlertSliderVisible({ visible: false });
  }

  private closeSupportCaseSlider() {
    console.warn('inside close suport');
    this.setSupportCaseSliderVisible({ visible: false });
  }
  getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth,
    );
  }
  mounted() {
    this.storePageViewWidth({ width:this.getWidth() });
    // this.isUserAuthorized();
    // this.dropOldUsersIdbs();
    feedbackWorkspace = () => {
      this.showFeedBackDialog = true;
    };
    this.$route.query && this.$route.query.mode === 'APP' ? this.addClass = true : this.addClass = false;
    window.location.href.includes('//cloud') ? this.isSpoginUrl = true : this.isSpoginUrl = false;
    console.warn('checking for cloud', this.addClass, this.isSpoginUrl);
  }

  // dropOldUsersIdbs() {
  //   try {
  //     // @ts-ignore
  //     indexedDB.databases()
  //     .then((arr: any) => {
  //       arr.forEach((element: any) => {
  //         if (element.name !== this.$store.getters.getUserId) {
  //           indexedDB.deleteDatabase(element.name);
  //         }
  //       });
  //     });
  //   } catch (e) {
  //     const stores = localStorage.getItem('UnclearedIdbs');
  //     if (stores) {
  //       JSON.parse(stores)
  //       .forEach((store: string) => {
  //         if (store !== this.$store.getters.getUserId) {
  //           indexedDB.deleteDatabase(store);
  //         }
  //       });
  //     }
  //     if (isChrome) {
  //       console.warn(e);
  //     }
  //   }
  // }

  created() {
    if (window.location.href.indexOf('spog-homepage') > -1) {
      this.removeMinCriteria = true;
    }
    const currentUser : any = localStorage.getItem(currentUserKey);
    this.showSpogCurtain = currentUser && JSON.parse(currentUser)?.spogUser && (this.$route.query.mode !== 'APP') && !(window.location.href.indexOf('spog-homepage') > -1);
    if (!this.showSpogCurtain) {
      this.defconDialogSrc = `${envCongif.spog_url}/homepage?embed=YES`;
      console.warn(this.defconDialogSrc);
    }
    if (true) {
      window.addEventListener('message', (e : Event) => {
        this.spogEventListner(e);
      });
    }
    const lsStores = localStorage.getItem('clearIdbStores');
    if (lsStores) {
      const stores: any[] = JSON.parse(lsStores);
      stores.forEach((store) => {
        idb.removeItem(store);
      });
    }
    localStorage.setItem('clearIdbStores', JSON.stringify([]));
    if (location.pathname.indexOf('feature/spog-homepage') > -1 || location.pathname.indexOf('feature/unified-insights') > -1) {
      this.hideHeaderInSpog = false;
    } else {
      this.hideHeaderInSpog = true;
    }
    if (window.navigator.language === 'ja') {
      i18nService.changeLang('ja-JP');
    } else if (window.navigator.language === 'zh-CN') {
      i18nService.changeLang('zh-CN');
    } else {
      i18nService.changeLang('en-US');
    }
  }

  toggleCurtain(close : any) {
    const curtain = this.$refs.curtain as HTMLElement;
    const overlay = this.$refs.overlay as HTMLElement;
    const innerVerticalPuller = this.$refs.innerVerticalPuller as HTMLElement;
    if (close) {
      curtain.style.top = '-200%';
      overlay.style.display = 'none';
    } else {
      innerVerticalPuller.style.transform = 'rotate(360deg)';
      curtain.style.top = '0';
      overlay.style.display = 'block';
    }
  }

  spogEventListner(event : any) {
    if (event.data.closeCurtain) {
      this.toggleCurtain(true);
      const curtainFrame = this.$refs.mswCurtainFrame as HTMLFrameElement;
      if (curtainFrame !== null) {
        curtainFrame.contentWindow!.postMessage({
          closedCurtain: true,
          service: event.data.service,
          navigateUrl: event.data.navigateUrl,
        },                                      '*');
      }
    }
  }
  // isUserAuthorized() {
  //   this.authorizedUser = JSON.parse(this.$store.getters.getUserInfo).user.roles
  //     .indexOf('WORKSPACEBETA') !== -1;
  //   if (!this.authorizedUser && window.location.href.indexOf('spog-homepage') > -1) {
  //     this.authorizedUser = JSON.parse(this.$store.getters.getUserInfo).user.roles
  //     .indexOf('SPOGREADONLY') !== -1;
  //   }
  // }
}
